import React, { useCallback, useEffect } from 'react';

import UserCreationContext from './UserCreationContext';
import { SharedFolder } from '../../../../services/openapi/models/SharedFolder';

interface IUserCreationContextProviderProps {
    children?: React.ReactNode;
}
const UserCreationContextProvider = ({ children }:IUserCreationContextProviderProps) => {
    // Lift the value into the parent’s state: https://reactjs.org/docs/context.html#caveats

   
    const [code, setCode] = React.useState<string>("");
    const [email, setEmail] = React.useState<string>("");
    const [name, setName] = React.useState<string>("");
    const [kundennummer, setKundennummer] = React.useState<string>("");
    const [isOwner, setIsOwner] = React.useState<boolean>(false);
    const[accessibleFolders, setAccessibleFolders] = React.useState<SharedFolder[]>([]);
    const[userGroups, setUserGroups] = React.useState<string[]>([]);
    const[Ansprechpartner, setAnsprachpartner] = React.useState<string>("");
    const[Mail_Ansprechpartner, setMail_Ansprachpartner] = React.useState<string>("");


    const resetUserPreConf = () => {
        setCode("");
        setEmail("");
        setName("");
        setKundennummer("");
        setIsOwner(false);
        setAccessibleFolders([]);
        setUserGroups([]);
        setAnsprachpartner("");
        setMail_Ansprachpartner("");


    }
    

    const buildEnvelope = useCallback(() => {
        return {
            email: email.trim(),
            name: name,
            kundenummer: kundennummer,
            isOwner: isOwner,
            usergroups: userGroups,
            folders: accessibleFolders.map((el) => ({ key: el.key, label: el.label })),
            Ansprechpartner: Ansprechpartner,
            Mail_Anprechpartner: Mail_Ansprechpartner

    
        }
    },[email, name, kundennummer, isOwner, userGroups, accessibleFolders,Ansprechpartner,Mail_Ansprechpartner]) 

return (
    <UserCreationContext.Provider
        value={{
            code,
            setCode,
            email,
            setEmail,
            name,
            setName,
            kundennummer,
            setKundennummer,
            isOwner,
            setIsOwner,
            accessibleFolders,
            setAccessibleFolders,

userGroups,
setUserGroups,
Ansprechpartner,
setAnsprachpartner,
Mail_Ansprechpartner,
setMail_Ansprachpartner,
resetUserPreConf,
buildEnvelope


        }}
    >
    <>
        {children}
    </>
    </UserCreationContext.Provider>
);
};

export default UserCreationContextProvider;
